// All PostHog events for web in one place
export const PH_EVENTS_WEB = {
  LOGIN_COMPLETED_DURING_CHECKOUT: `purchase_v1:web:login_completed_during_checkout`,
  SIGNUP_COMPLETED_DURING_CHECKOUT: `purchase_v1:web:signup_completed_during_checkout`,
  SIGNUP_INITIATED_DURING_CHECKOUT: `purchase_v1:web:signup_initiated_during_checkout`,
  CHECKOUT_INITIATED: `purchase_v1:web:checkout_initiated`,
  // PURCHASE_COMPLETED: `purchase_v1:web:purchase_completed`, // TODO: Add this event
} as const;

export type PosHogWebEventName =
  (typeof PH_EVENTS_WEB)[keyof typeof PH_EVENTS_WEB];
